
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import "rxjs/Rx";

import { environment } from '../../environments/environment';

import { Baseservice } from './baseservice'

import { AuthenticationService } from './authentication.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class RunCorrespondenceTasksService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super("correnspondence-tasks", http, authentication);
  }
  CreatePermitsExpiryReminder() {
    return this.http.get(this.url + "/expiring-permits-reminder");
  }
  CreatePermitsExpiredReminder() {
    return this.http.get(this.url + "/expired-permits-reminder");
  }
  CreatePermitsNotReturnedReminders() {
    return this.http.get(this.url + "/permits-not-returned-reminder");
  }
  CreateMessagesForFeesDue() {
    return this.http.get(this.url + "/messages-for-fees-due");
  }
  CreateApprovedPermitsNeedingConfirm() {
    return this.http.get(this.url + "/approved-permits-needing-confirm");
  }
  InvoicePermits(){
    return this.http.get(this.url + "/invoice/permits"); 
  }

  FirstCompliance(){
    return this.http.get(this.url + "/compliance/firstreminder"); 
  }

  SecondCompliance(){
    return this.http.get(this.url + "/compliance/secondreminder"); 
  }

  ThirdCompliance(){
    return this.http.get(this.url + "/compliance/thirdreminder"); 
  }

}
